import React, { useState } from 'react';
import Navigate from './Navigate';
import SideBar from './SideBar';
import Shadow from './Shadow';

const Header = () => {
    const [showMenu, setShowMenu] = useState(false);

    const toggleSidebar = ()=>{
        setShowMenu(!showMenu);
    }

    return (
        <div className='overscroll-none relative '>
            <SideBar show={showMenu}  />
            <Shadow show={showMenu} toggle={toggleSidebar} />
            <Navigate toggle={toggleSidebar} />
        </div>
    );
}

export default Header;